import { render } from "./Term.vue?vue&type=template&id=4e81dbd2"
import script from "./Term.vue?vue&type=script&lang=js"
export * from "./Term.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__